/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { ChevronDown, ChevronUp, MinusCircle, Download } from 'lucide-react'
import { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
  Table
} from 'react-bootstrap'
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams
} from 'react-router-dom'
import Swal from 'sweetalert2'
import {
  BadgeStatusOutboundPlan,
  BadgeStatusPrListInbounds
} from '../../../components/atoms/StatusLabel'
import CustomButton from '../../../components/Button/CustomButton'
import ModalUpdateVehicleOutboundPlan from '../../../components/modal/Outbound/Plan/ModalUpdateVehicleOutboundPlan'
import Notification from '../../../components/Notifications/Notification'
import api from '../../../config/AxiosInstance'
import {
  convertDateWithoutTime,
  convertDateWithTime
} from '../../../helpers/constants'
import * as Common from '../../../utils/Common'
import {
  firstLetterUpperCase,
  formatThousandSeparator
} from '../../../utils/TextFormatter'
import ActionButton from './ActionButton'
import Select from 'react-select'
import Loading from '../../../components/atoms/Loading'
import ModalSelectFormat from '../../../components/modal/Sj/ModalSelectFormat'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const cardStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const labelDetailStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#999',
  textTransform: 'uppercase',
  marginBottom: '0.25rem',
  letterSpacing: '0.5px'
}

const StyledDetailField = ({ label, value, col = 3, children }) => {
  return (
    <Form.Group className={`mb-3 col-12 col-md-${col}`}>
      <Form.Label style={labelDetailStyle}>{label}</Form.Label>
      <div
        className="px-0"
        style={{
          fontSize: '0.9rem',
          fontWeight: '500',
          color: '#212529',
          minHeight: '24px'
        }}
      >
        {children ? children : value}
      </div>
    </Form.Group>
  )
}

const statusProperty = [
  'pnp_picking',
  'waiting_om',
  'request_loading',
  'finish_loading',
  'loading',
  'ready',
  'on_delivery',
  'done'
]

const DetailOutboundPlan = () => {
  const navigate = useNavigate()
  let [searchParams, setSearchParams] = useSearchParams()
  const { code } = useParams()
  const { state } = useLocation()
  const [selectFormatDownload, setSelectFormatDownload] = useState({
    type: 'sj',
    format: null,
    action: null,
    id: null
  })
  const [showNotificationUpdate, setShowNotificationUpdate] = useState(false)
  const [isLoadingPage, setIsLoadingPage] = useState(false)
  const [loadingSubmitTicket, setLoadingSubmitTicket] = useState(false)
  const [loadingRemoveSj, setLoadingRemoveSj] = useState({})
  const [showModalUpdateVehicle, setShowModalUpdateVehicle] = useState(false)
  const [progressDetailCommand, setProgressDetailCommand] = useState(true)
  const [showModalSelectFormat, setShowModalSelectFormat] = useState(false)
  const [loadingFormat, setLoadingFormat] = useState(false)
  const [updateVehicle, setUpdateVehicle] = useState({
    step: 1,
    type: 'internal',
    vehicle_id: '',
    driver_id: '',
    sim: null,
    memo: null,
    stnk: null
  })
  const [outboundPlan, setOutboundPlan] = useState({})
  const [total, setTotal] = useState({
    qty: '',
    pack: '',
    volume: ''
  })

  const customMultiStyles = {
    control: (base) => ({
      ...base,
      height: 33,
      minHeight: 33,
      ':hover': {
        borderColor: 'hsl(0, 0%, 90%)'
      }
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '30px',
      padding: '0 6px',
      display: 'flex',
      flexWrap: 'nowrap',
      overflowX: 'auto',
      maxWidth: '100%',
      scrollbarWidth: 'thin',
      scrollbarColor: '#ccc transparent',
      pointerEvents: 'auto'
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      order: -1,
      marginRight: '8px',
      ':hover': {
        backgroundColor: 'none',
        cursor: 'default'
      }
    }),
    multiValue: (provided) => ({
      ...provided,
      marginTop: '-0.01rem',
      whiteSpace: 'nowrap',
      maxWidth: 'none',
      minWidth: 'none',
      width: 'fit-content',
      backgroundColor: 'white',
      boxShadow: '0px 1px 1px rgba(0, 0, 0, 0.10)',
      borderRadius: '4px',
      border: '1px solid #E0E0E0',
      marginBottom: '4px'
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      marginLeft: '-1rem',
      display: 'inline-flex',
      gap: 2,
      whiteSpace: 'nowrap',
      overflow: 'visible',
      textOverflow: 'clip',
      width: 'fit-content'
    }),
    input: (provided) => ({
      ...provided,
      margin: '0px'
    })
  }

  useEffect(() => {
    // when code falsy redirect to page outbound plan
    if (!code) {
      navigate('/outbound/plan')
    }
    const timeoutCloseNotification = setTimeout(() => {
      setShowNotificationUpdate(false)
    }, 10000)

    fetchDetailOutboundPlan()
    return () => {
      clearTimeout(timeoutCloseNotification)
    }
  }, [code])

  useEffect(() => {
    setTotal({
      qty: calculateTotalQty('qty'),
      pack: calculateTotalQty('pack'),
      volume: calculateTotalVolume()
    })
  }, [outboundPlan])

  const handleRemoveSj = (id) => {
    Swal.fire({
      title: 'Remove SJ draft?',
      text: 'This action can’t be undone',
      icon: 'warning',
      iconColor: '#828282',
      showCancelButton: true,
      confirmButtonColor: '#C12727',
      cancelButtonColor: 'transparent',
      confirmButtonText: 'Remove',
      showCloseButton: true,
      customClass: {
        title: 'swal-title-outbound',
        popup: 'swal-popup-outbound',
        actions: 'swal-remove-outbound'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        removeDataSj(id)
      }
    })
  }

  const removeDataSj = async (id) => {
    try {
      setLoadingRemoveSj((prevLoadingRemoveSj) => ({
        ...prevLoadingRemoveSj,
        [id]: true
      }))
      const res = await api.delete(`outbound/sjdraft/${id}`)
      if (res.status === 200) {
        const existDataSjDraft = outboundPlan?.sj_drafts?.filter(
          (sj_draft) => sj_draft.sj_draft_id !== id
        )?.length
        if (!existDataSjDraft) {
          return navigate('/outbound/plan', { replace: true })
        }
        fetchDetailOutboundPlan()
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingRemoveSj((prevLoadingRemoveSj) => ({
        ...prevLoadingRemoveSj,
        [id]: false
      }))
    }
  }

  const fetchDetailOutboundPlan = async () => {
    try {
      setIsLoadingPage(true)
      const res = await api.get(`/outbound/outbound_plan/${code}`, {
        params: {
          notif_id: searchParams.get('notif_id')
        }
      })
      if (res.status === 200) {
        setOutboundPlan({
          ...res.data.data,
          other_warehouses:
            res.data.data?.other_warehouses?.map((other_warehouse) => ({
              label: other_warehouse.warehouse_id,
              value: other_warehouse.warehouse_id
            })) || []
        })
        setUpdateVehicle({
          step: 1,
          type: res.data.data.delivery_type ?? 'internal',
          vehicle_id: res.data.data.vehicle_id,
          driver_id: res.data.data.driver_id,
          sim: res.data.data.sim,
          memo: res.data.data.sim,
          stnk: res.data.data.stnk
        })
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setIsLoadingPage(false)
    }
  }

  const calculateTotalQty = (type) => {
    let qtyMap = []
    if (outboundPlan?.sj_drafts?.length > 0) {
      outboundPlan?.sj_drafts?.forEach((sjValue) => {
        sjValue.pick_up_commands.forEach((command) => {
          if (type === 'qty') {
            const { qty, uom } = command
            if (qtyMap.length === 0) {
              qtyMap.push({ qty, uom })
            } else {
              const filterQty = qtyMap.filter(
                (dataValue) => dataValue.uom === uom
              )
              if (filterQty.length > 0) {
                const newValues = qtyMap.map((value) =>
                  value.uom === uom
                    ? { ...value, qty: (value.qty += qty) }
                    : value
                )
                qtyMap = newValues
              } else {
                qtyMap.push({ qty, uom })
              }
            }
          }
          if (type === 'pack') {
            const { total_pack, uom_pack } = command
            if (qtyMap.length === 0) {
              qtyMap.push({ qty: total_pack, uom: uom_pack })
            } else {
              const filterQty = qtyMap.filter(
                (dataValue) => dataValue.uom === uom_pack
              )
              if (filterQty.length > 0) {
                const newValues = qtyMap.map((value) =>
                  value.uom === uom_pack
                    ? { ...value, qty: (value.qty += total_pack) }
                    : value
                )
                qtyMap = newValues
              } else {
                qtyMap.push({ qty: total_pack, uom: uom_pack })
              }
            }
          }
        })
      })
      const totalQty = qtyMap
        .map((data) => `${data.qty} ${data.uom}`)
        .join(' + ')
      return totalQty
    }
    return 0
  }

  const calculateTotalVolume = () => {
    if (outboundPlan?.sj_drafts?.length > 0) {
      let tmpVolume = []
      outboundPlan?.sj_drafts?.forEach((sjValue) => {
        sjValue.pick_up_commands?.forEach((pickupCommand) => {
          let calculateTotalVolume = 0
          if (Number(pickupCommand.volume_item) !== 0) {
            calculateTotalVolume =
              Number(pickupCommand.qty) * Number(pickupCommand.volume_item)
          } else {
            calculateTotalVolume =
              (Number(pickupCommand.qty) /
                (Number(pickupCommand.qty) /
                  Number(pickupCommand.total_pack))) *
              1000000
          }
          tmpVolume.push(calculateTotalVolume)
        })
      })

      if (tmpVolume.length > 0) {
        const totalVolume = tmpVolume.reduce((acc, volume) => {
          return (acc += volume ?? 0)
        }, 0)
        return totalVolume
      }
    }
    return 0
  }

  const formatDeliveryDateRange = () => {
    if (outboundPlan?.delivery_date_start && outboundPlan?.delivery_date_end) {
      return `${convertDateWithoutTime(outboundPlan.delivery_date_start)} - ${convertDateWithoutTime(outboundPlan.delivery_date_end)}`
    }
    const sjDates = (outboundPlan?.sj_drafts || [])
      .map((sj) => sj.delivery_date)
      .filter(Boolean)
      .sort()

    if (sjDates.length > 0) {
      const start = sjDates[0]
      const end = sjDates[sjDates.length - 1]
      return `${convertDateWithoutTime(start)} - ${convertDateWithoutTime(end)}`
    }

    if (outboundPlan?.delivery_date) {
      return convertDateWithoutTime(outboundPlan.delivery_date)
    }

    return '-'
  }

  const handleUpdateVehicle = (name, value) => {
    setUpdateVehicle((prevUpdateVehicle) => ({
      ...prevUpdateVehicle,
      [name]: value
    }))
  }

  const handleUploadFile = (e = '', action) => {
    if (action === 'upload') {
      const { name, files } = e?.target
      setUpdateVehicle((prevFiles) => ({ ...prevFiles, [name]: files[0] }))
    }
    if (action === 'delete') {
      setUpdateVehicle((prevFiles) => ({ ...prevFiles, [e]: null }))
    }
  }

  const handleSubmitTicket = async () => {
    try {
      setLoadingSubmitTicket(true)
      const res = await api.post(
        `/outbound/outbound_plan/${outboundPlan?.outbound_plan_id}/submit-ticket`
      )
      if (res.data.success) {
        fetchDetailOutboundPlan(outboundPlan?.outbound_plan_id)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoadingSubmitTicket(false)
    }
  }

  const propertySubmitTicket = () => {
    if (loadingSubmitTicket) {
      return {
        text: 'Loading...',
        disabled: true,
        color: 'secondary'
      }
    }
    if (
      (outboundPlan?.sj_drafts?.filter(
        (sjDraft) => sjDraft.status === 'problem'
      ).length === 0 &&
        outboundPlan?.outbound_problem) ||
      (outboundPlan?.sj_drafts?.filter(
        (sjDraft) => sjDraft.status === 'problem'
      ).length === 0 &&
        !outboundPlan?.outbound_problem &&
        outboundPlan?.delivery_type)
    ) {
      return {
        text: 'Submit Ticket',
        disabled: false,
        color: 'warning'
      }
    }

    return {
      text: 'Submit Ticket',
      disabled: true,
      color: 'secondary'
    }
  }

  const handleDownloadList = async (value) => {
    try {
      let url =
        value === 'packing_list'
          ? `/outbound/outbound_plan/${outboundPlan?.outbound_plan_id}/download_packing_list`
          : `/outbound/outbound_plan/${outboundPlan?.outbound_plan_id}/download_checklist_armada`
      const res = await api.get(url, { responseType: 'arraybuffer' })
      const { status, data } = res

      if (status === 200) {
        const blob = new Blob([data], { type: 'application/pdf' })
        const urlDownload = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = urlDownload
        link.setAttribute(
          'download',
          `file_${value}_${outboundPlan.outbound}.pdf`
        )
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const handlePrintDownloadAllSj = async () => {
    try {
      setLoadingFormat(true)
      const res = await api.get(
        `/outbound/outbound_plan/${code}/download_sj_all?print=${encodeURIComponent(
          selectFormatDownload?.format
        )}&action=${selectFormatDownload.action}`,
        {
          responseType:
            selectFormatDownload.action === 'print' ? 'text' : 'arraybuffer'
        }
      )
      const { status, data, headers } = res
      if (status === 200) {
        const contentType = headers?.['content-type'] || ''
        if (selectFormatDownload.action === 'print') {
          if (contentType.includes('text/html') || typeof data === 'string') {
            Common.printDocument(data, true)
          } else {
            const blob = new Blob([data], { type: 'application/pdf' })
            Common.printDocument(blob)
          }
        } else if (selectFormatDownload.action === 'download') {
          const blob = new Blob([data], { type: 'application/pdf' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `file-all-sj-${code}.pdf`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        }
      }
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setShowModalSelectFormat(false)
      setLoadingFormat(false)
    }
  }

  if (isLoadingPage) {
    return <Loading />
  }

  return (
    <>
      <div className="container mb-3">
        <div className="row">
          <div
            className={
              statusProperty.some((status) => status === outboundPlan?.status)
                ? 'col-4'
                : 'col-12'
            }
          >
            <h4 style={headerTitleStyle} className="d-flex flex-row gap-2">
              <p>{outboundPlan?.outbound}</p>
              <sup className="ml-3">
                <BadgeStatusOutboundPlan text={outboundPlan?.status} />
              </sup>
            </h4>
          </div>
          {statusProperty.some((status) => status === outboundPlan?.status) && (
            <ActionButton>
              {outboundPlan?.sj_drafts?.filter(
                (sjDraft) => sjDraft.status === 'problem'
              ).length === 0 &&
                !outboundPlan?.outbound_problem && (
                  <>
                    <CustomButton
                      variant={'transparent'}
                      style={{ borderColor: '#F89D1D', whiteSpace: 'nowrap' }}
                      classNameValue={`${
                        outboundPlan?.status === 'finish_loading' ||
                        outboundPlan?.status === 'on_delivery' ||
                        outboundPlan?.status === 'done'
                          ? 'd-block'
                          : 'd-none'
                      } text-warning fw-bold`}
                      onClick={() => handleDownloadList('checklist_armada')}
                      text={
                        <>
                          <Download size={14} className="me-2" />
                          <span>Checklist Armada</span>
                        </>
                      }
                    />
                    {!outboundPlan?.sj_drafts?.every(
                      (typeOutbound) => typeOutbound.is_rr
                    ) && (
                      <CustomButton
                        variant={'transparent'}
                        style={{ borderColor: '#F89D1D', whiteSpace: 'nowrap' }}
                        classNameValue={`text-warning fw-bold ${
                          outboundPlan?.status === 'waiting_om'
                            ? 'd-none'
                            : 'd-block'
                        }`}
                        text={'Download Packing List'}
                        onClick={() => handleDownloadList('packing_list')}
                      />
                    )}
                    {['finish_loading', 'on_delivery', 'done'].includes(
                      outboundPlan?.status
                    ) &&
                      outboundPlan?.sj_drafts?.some(
                        (sjDraft) => sjDraft.type === 'sj'
                      ) && (
                        <>
                          <CustomButton
                            variant={'transparent'}
                            style={{ whiteSpace: 'nowrap' }}
                            onClick={() => {
                              setShowModalSelectFormat(true)
                              setSelectFormatDownload(
                                (prevSelectFormatDownload) => ({
                                  ...prevSelectFormatDownload,
                                  id: code,
                                  action: 'print'
                                })
                              )
                            }}
                            classNameValue="btn-primary-blue fw-bold"
                            text={
                              <>
                                <span>Print All SJ</span>
                              </>
                            }
                          />
                          <CustomButton
                            variant={'transparent'}
                            style={{ whiteSpace: 'nowrap' }}
                            onClick={() => {
                              setShowModalSelectFormat(true)
                              setSelectFormatDownload(
                                (prevSelectFormatDownload) => ({
                                  ...prevSelectFormatDownload,
                                  id: code,
                                  action: 'download'
                                })
                              )
                            }}
                            classNameValue="btn-primary-orange fw-bold"
                            text={
                              <>
                                <span>Download All SJ</span>
                              </>
                            }
                          />
                        </>
                      )}
                    <CustomButton
                      variant={'transparent'}
                      style={{
                        backgroundColor: '#203568',
                        whiteSpace: 'nowrap'
                      }}
                      text={'Update Vehicle'}
                      onClick={() => setShowModalUpdateVehicle(true)}
                      classNameValue="fw-bold text-white"
                    />
                  </>
                )}
              {outboundPlan?.status === 'waiting_om' && (
                <>
                  {(outboundPlan?.sj_drafts.filter(
                    (sjDraft) => sjDraft.status === 'problem'
                  ).length > 0 ||
                    outboundPlan?.outbound_problem) && (
                    <p
                      className="text-danger mt-3 fw-bold"
                      style={{ fontSize: '12px' }}
                    >
                      Please solve problem from all SJ to submit
                    </p>
                  )}

                  <CustomButton
                    variant={propertySubmitTicket().color}
                    style={{ whiteSpace: 'nowrap' }}
                    disabled={propertySubmitTicket().disabled}
                    onClick={() =>
                      handleSubmitTicket(outboundPlan?.outbound_plan_id)
                    }
                    text={propertySubmitTicket().text}
                  />
                </>
              )}
            </ActionButton>
          )}
          {showNotificationUpdate && (
            <Notification
              type="success"
              text="Driver and Vehicle Updated!"
              handleClose={() => setShowNotificationUpdate(false)}
            />
          )}
        </div>
        <div className="row">
          <nav aria-label="breadcrumb">
            <ol
              className="breadcrumb"
              style={{ fontSize: '12px', cursor: 'pointer' }}
            >
              <li
                className="breadcrumb-item sj-item"
                onClick={() => navigate('/outbound/plan', { state: state })}
              >
                <span className="text-black fw-bold">OUTBOUND</span>
              </li>
              <li
                className="breadcrumb-item sj-item active text-uppercase"
                aria-current="page"
              >
                {outboundPlan?.outbound}
              </li>
            </ol>
          </nav>
        </div>
        <Card style={cardStyle}>
          <Row className="mb-3">
            <StyledDetailField
              label="SOURCE WAREHOUSE"
              value={outboundPlan?.warehouse_name}
              col={4}
            />
            <StyledDetailField
              label="External and consignment warehouse"
              col={4}
            >
              <Select
                name="other_src"
                options={outboundPlan?.other_warehouses || []}
                isClearable
                isSearchable
                isMulti
                styles={customMultiStyles}
                value={outboundPlan?.other_warehouses || []}
                isDisabled
              />
            </StyledDetailField>
            <StyledDetailField
              label="DELIVERY DATE"
              value={formatDeliveryDateRange()}
              col={4}
            />
          </Row>
          <Row>
            <StyledDetailField
              label="CAR"
              value={outboundPlan?.vehicle_name}
              col={4}
            />
            <StyledDetailField
              label="DRIVER"
              value={outboundPlan?.driver_name}
              col={4}
            />
            <StyledDetailField
              label="DELIVERY TYPE"
              value={firstLetterUpperCase(outboundPlan?.delivery_type)}
              col={4}
            />
          </Row>
        </Card>
      </div>
      <Container>
        <Row className="mb-3">
          <Col xs={12} md={12} lg={12}>
            <Card style={cardStyle}>
              <Row>
                <Col xs={12} md={4} lg={4}>
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <span style={labelDetailStyle}>Total Qty</span>
                    <span className="fw-bold text-orange fs-5">
                      {total.qty}
                    </span>
                  </div>
                </Col>
                <Col
                  xs={12}
                  md={4}
                  lg={4}
                  style={{ borderLeft: '1px solid #e0e0e0' }}
                >
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <span style={labelDetailStyle}>Total Pack</span>
                    <span className="fw-bold text-orange fs-5">
                      {total.pack}
                    </span>
                  </div>
                </Col>
                <Col
                  xs={12}
                  md={4}
                  lg={4}
                  style={{ borderLeft: '1px solid #e0e0e0' }}
                >
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <span style={labelDetailStyle}>Total Volume</span>
                    <span className="fw-bold text-orange fs-5">
                      {formatThousandSeparator(total.volume)} cm³
                    </span>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>

      <Container>
        <Row className="mt-3">
          <Col xs={12} md={12} lg={12}>
            {outboundPlan?.sj_drafts?.map((itemCommand, index) => (
              <ListDataSj
                key={itemCommand.id}
                data={itemCommand}
                number={index + 1}
                onHandleRemoveSj={handleRemoveSj}
                status={outboundPlan?.status}
                outboundPlanId={outboundPlan?.outbound_plan_id}
                outboundPlanCode={outboundPlan?.outbound}
                loadingRemoveSj={loadingRemoveSj}
              />
            ))}
          </Col>
        </Row>
      </Container>
      <Container>
        <Card style={cardStyle} className="mt-4">
          <div
            className="d-flex justify-content-between align-items-center cursor-pointer mb-3"
            onClick={() => setProgressDetailCommand(!progressDetailCommand)}
            style={{ cursor: 'pointer' }}
          >
            <h5 className="m-0 fw-bold text-dark" style={{ fontSize: '1rem' }}>
              PROGRESS DETAIL
            </h5>
            <Button variant="transparent" className="p-0 text-secondary">
              {progressDetailCommand ? (
                <ChevronUp size={16} />
              ) : (
                <ChevronDown size={16} />
              )}
            </Button>
          </div>
          <Collapse in={progressDetailCommand}>
            <div id="progress-collapse" className="mt-4 ms-3 position-relative">
              <div
                className="position-absolute"
                style={{
                  top: '0',
                  bottom: '0',
                  left: '6px',
                  borderLeft: '2px solid #e9ecef',
                  zIndex: 0
                }}
              />
              {outboundPlan?.progress?.length > 0 ? (
                outboundPlan?.progress?.map((progress, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-start mb-3 position-relative"
                    style={{ zIndex: 1 }}
                  >
                    <div
                      className="d-flex align-items-center justify-content-center bg-white"
                      style={{
                        width: '14px',
                        height: '14px',
                        borderRadius: '50%',
                        border: '2px solid var(--primary-orange)',
                        marginTop: '4px',
                        marginRight: '1rem',
                        flexShrink: 0
                      }}
                    >
                      <div
                        style={{
                          width: '6px',
                          height: '6px',
                          borderRadius: '50%',
                          backgroundColor: 'var(--primary-orange)'
                        }}
                      />
                    </div>
                    <div className="w-100">
                      <div
                        className="text-secondary small mb-1"
                        style={{ fontSize: '0.75rem', marginTop: '2px' }}
                      >
                        {progress?.datetime || '-'}
                      </div>
                      <div
                        className="fw-bold text-dark"
                        style={{ fontSize: '0.9rem' }}
                      >
                        {progress?.description}
                        {progress?.detail?.length > 0 && (
                          <ul
                            className="list-unstyled mt-2 mb-0"
                            style={{ marginLeft: '1rem' }}
                          >
                            {progress?.detail?.map((detail, idx) => (
                              <li
                                key={idx}
                                style={{
                                  color: `${detail.color || 'black'}`,
                                  fontSize: '0.85rem'
                                }}
                                className="mb-1"
                              >
                                {detail?.description}
                              </li>
                            ))}
                          </ul>
                        )}
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="p-3 text-muted fst-italic">Data Empty!</div>
              )}
            </div>
          </Collapse>
        </Card>
      </Container>
      <Container>
        <Row className="mt-3 mb-5">
          <Col xs={12} md={12} lg={12}>
            <Card style={cardStyle}>
              <Row>
                <StyledDetailField
                  label="CREATED BY"
                  value={outboundPlan?.createdby}
                  col={3}
                />
                <StyledDetailField
                  label="CREATED AT"
                  value={convertDateWithTime(outboundPlan?.createdAt)}
                  col={3}
                />
                <StyledDetailField
                  label="LAST UPDATED BY"
                  value={outboundPlan?.updatedby}
                  col={3}
                />
                <StyledDetailField
                  label="LAST UPDATED AT"
                  value={convertDateWithTime(outboundPlan?.updatedAt)}
                  col={3}
                />
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
      <ModalSelectFormat
        show={showModalSelectFormat}
        handleClose={() => {
          setShowModalSelectFormat(false)
          setSelectFormatDownload((prevSelectFormatDownload) => ({
            ...prevSelectFormatDownload,
            id: null,
            format: null
          }))
        }}
        setSelectFormatDownload={setSelectFormatDownload}
        selectFormatDownload={selectFormatDownload}
        handleDownloadPrint={handlePrintDownloadAllSj}
        loadingFormat={loadingFormat}
      />
      <ModalUpdateVehicleOutboundPlan
        show={showModalUpdateVehicle}
        onHide={() => {
          setShowModalUpdateVehicle(false)
          setUpdateVehicle({
            step: 1,
            type: outboundPlan?.delivery_type,
            vehicle_id: outboundPlan?.vehicle_id,
            driver_id: outboundPlan?.driver_id,
            sim: outboundPlan?.sim,
            memo: outboundPlan?.memo,
            stnk: outboundPlan?.stnk
          })
        }}
        updateVehicle={updateVehicle}
        handleUpdateVehicle={handleUpdateVehicle}
        handleUploadFile={handleUploadFile}
        totalVolume={calculateTotalVolume()}
        outboundPlanId={outboundPlan?.outbound_plan_id}
        refreshData={() => fetchDetailOutboundPlan(outboundPlan?.outbound)}
        isTr={
          outboundPlan?.sj_drafts?.filter((sj_draft) => sj_draft.is_tr)
            ?.length > 0
            ? true
            : false
        }
        warehouseId={outboundPlan?.warehouse_id}
      />
    </>
  )
}

const ListDataSj = ({
  data,
  number,
  onHandleRemoveSj,
  status,
  loadingRemoveSj,
  outboundPlanId,
  outboundPlanCode
}) => {
  const propsCancelSj = () => {
    if (loadingRemoveSj[data.sj_draft_id]) {
      return {
        key: data.sj_draft_id,
        variant: 'secondary',
        className: 'fw-bold',
        size: 'sm',
        disabled: true,
        children: (
          <div className="d-flex flex-row gap-2">
            <span>REMOVE</span>
            <MinusCircle size={14} color="white" className="ml-2 mt-1" />
          </div>
        )
      }
    }
    return {
      key: data.sj_draft_id,
      variant: 'danger',
      className: 'fw-bold',
      size: 'sm',
      onClick: () => onHandleRemoveSj(data.sj_draft_id),
      children: (
        <div className="d-flex flex-row gap-2">
          <span>REMOVE</span>
          <MinusCircle size={14} color="white" className="ml-2 mt-1" />
        </div>
      )
    }
  }
  const generateURL = (data) => {
    if (data?.type === 'sj') {
      return `/outbound/sj/detail/${encodeURIComponent(
        data?.code.split(' - ')[0]
      )}`
    }
    if (data?.type === 'rr') {
      return `/outbound/request-return/detail/${encodeURIComponent(
        data?.code.split(' - ')[0]
      )}`
    }
    return `/outbound/transfer/detail/${encodeURIComponent(data.sj_draft_id)}`
  }
  return (
    <Card style={cardStyle}>
      <Col>
        <Row>
          <Col xs={12} md={8} lg={8}>
            <p className="d-flex flex-row gap-2">
              <span className="fw-bold mr-2">
                {number}.{' '}
                <Link
                  to={`${generateURL(
                    data
                  )}?outboundId=${outboundPlanId}&outboundCode=${outboundPlanCode}`}
                  className="text-decoration-none"
                >
                  {data?.code.split(' - ')[0]}
                </Link>{' '}
                - {data?.code.split(' - ')[1]}
              </span>
              <sup className="ml-2" style={{ fontSize: '15px' }}>
                <BadgeStatusPrListInbounds text={data.status} />
              </sup>
            </p>
          </Col>
          <Col className="d-flex justify-content-end">
            {(status === 'unassigned' || status === 'waiting_pnp') &&
              data.status === 'waiting' && <Button {...propsCancelSj()} />}
          </Col>
        </Row>
      </Col>
      <Col xs={12} md={12} lg={12}>
        <Col xs={12} md={4} lg={4}>
          <p>{data.customer}</p>
        </Col>
      </Col>
      <Col xs={12} md={12} lg={12} className="mb-3">
        <Col xs={12} md={6} lg={6}>
          <div dangerouslySetInnerHTML={{ __html: data.delivery_address }} />
        </Col>
      </Col>
      <Col xs={12} md={12} lg={12} className="mt-2 mb-3">
        <Col xs={12} md={12} lg={12}>
          <div
            style={{
              color: 'var(--primary-orange)',
              fontSize: '13px',
              fontWeight: '500'
            }}
          >
            Rayon {data.rayon || '-'} &bull; Zoning {data.zoning || '-'} &bull;
            Delivery Date{' '}
            {data.delivery_date
              ? convertDateWithoutTime(data.delivery_date)
              : '-'}
          </div>
        </Col>
      </Col>
      <div className="col-12">
        <h6 className="fw-bold text-muted">PICK UP COMMAND</h6>
      </div>
      <div className="col-12 mt-3 pe-2">
        <Table
          hover
          className="mb-3"
          size="sm"
          responsive
          style={{ fontSize: '14px' }}
        >
          <thead
            className="table-secondary"
            style={{ borderColor: 'transparent' }}
          >
            <tr>
              <th className="p-2 align-middle" style={tableHeaderStyle}>
                No
              </th>
              <th className="p-2 align-middle" style={tableHeaderStyle}>
                Item Code - Name
              </th>
              <th className="p-2 align-middle" style={tableHeaderStyle}>
                Item Alias
              </th>
              <th
                className="p-2 align-middle text-end"
                style={tableHeaderStyle}
              >
                Batch
              </th>
              <th
                className="p-2 align-middle text-end"
                style={tableHeaderStyle}
              >
                Expired
              </th>
              <th
                className="p-2 align-middle text-end"
                style={tableHeaderStyle}
              >
                Base Qty UOM
              </th>
              <th
                className="p-2 align-middle text-end"
                style={tableHeaderStyle}
              >
                Qty Kemasan
              </th>
            </tr>
          </thead>
          <tbody>
            {data.pick_up_commands.length === 0 && (
              <tr>
                <td colSpan={7}>
                  <p className="fw-bold text-center">Item Empty</p>
                </td>
              </tr>
            )}
            {data.pick_up_commands.map((item, index) => (
              <ListPickupCommand data={item} number={index + 1} key={index} />
            ))}
          </tbody>
        </Table>
      </div>
    </Card>
  )
}

const ListPickupCommand = ({ data, number }) => {
  return (
    <tr key={data.id}>
      <td
        className="p-2 align-middle"
        style={{ backgroundColor: data?.item_alias ? '#FF8F8F' : '' }}
      >
        {number}
      </td>
      <td
        className="p-2 align-middle"
        style={{ backgroundColor: data?.item_alias ? '#FF8F8F' : '' }}
      >
        {data?.item_code} - {data?.item_name}
      </td>
      <td
        className="p-2 align-middle"
        style={{ backgroundColor: data?.item_alias ? '#FF8F8F' : '' }}
      >
        {data?.item_alias ?? '-'}
      </td>
      <td
        className="p-2 align-middle text-end"
        style={{ backgroundColor: data?.item_alias ? '#FF8F8F' : '' }}
      >
        {data?.batch}
      </td>
      <td
        className="p-2 align-middle text-end"
        style={{ backgroundColor: data?.item_alias ? '#FF8F8F' : '' }}
      >
        {data.exp_date ? data.exp_date : '-'}
      </td>
      <td
        className="p-2 align-middle text-end"
        style={{ backgroundColor: data?.item_alias ? '#FF8F8F' : '' }}
      >
        {!data?.qty?.toString().includes('.')
          ? data?.qty
          : data?.qty?.toFixed(2)}{' '}
        {data?.uom}
      </td>
      <td
        className="p-2 align-middle text-end"
        style={{ backgroundColor: data?.item_alias ? '#FF8F8F' : '' }}
      >
        {data?.total_pack} {data?.uom_pack}
      </td>
    </tr>
  )
}

export default DetailOutboundPlan
